// extracted by mini-css-extract-plugin
export default {"wrapper":"Step_wrapper__XoKJP","content":"Step_content__kbP43","number":"Step_number__w8SH7","title":"Step_title__rSjlS","text":"Step_text__Z5qyS"};